import Tpl from './ScheduleTableTpl';

export default class ScheduleTable {
    constructor(options) {
        this.option = options;
        console.log( ' schedule.js constructor() options : ', options );

        let _now  = new Date(this.option.now);
        let currentDate = {year: _now.getFullYear(), month: _now.getMonth() + 1 , day: _now.getDate(), hour: _now.getHours(), minute: _now.getMinutes(), dayOfWeek: _now.getDay()};

        this.wrap = this.option.wrap;
        this.currentDate = currentDate;
        this.standardDate = currentDate;
        this.PC_WIDTH = 960;
        this.SELECTED_COL = currentDate.dayOfWeek;
        this.objByTime = {};
        this.timer = null;

    }

    init() {

        console.log('# schedule.js init()');
        $(this.wrap).empty();
        this.sortData();

        $('.loadingbar', this.wrap).remove();

        this.drawTable();
        this.setEvent();
        this.setFooter();
    }

    sortData() {
        // 데이터 재배열 (요일순 > 시간순 정렬)
        let objByAlias = {},
            objTemp = {};

        $.each(this.option.timeTableData.data, (index, value) => {
            objByAlias[value.alias] = value;
        });

        console.log( ' SecheduleTable.js sortData() this.option.timeData.timeTable : ', this.option.timeData.timeTable );
        console.log( ' SecheduleTable.js sortData() this.option.timeTableData.data : ', this.option.timeTableData.data );

        $.each(this.option.timeData.timeTable, (key, value) => {
            for(let i = 0; i < value.length; i++) {
                if(!value[i].boxAlias) continue;
                let item = objByAlias[value[i].boxAlias];
                if(!item) continue;

                if(!objTemp[item.startTime]) {
                    objTemp[item.startTime] = {1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: []}; // (1~7) = (월~일)로 표기 통일
                }
                objTemp[item.startTime][key].push(item);
            }
        });
        
        Object.keys(objTemp).sort().forEach((key) => {
            this.objByTime[key] = objTemp[key];
        });

        console.log( ' SecheduleTable.js sortData() objTemp : ', objTemp );

    }

    drawTable() {
        console.log( 'drawTable() this.objByTime : ', this.objByTime);

        $(this.wrap).append(Tpl.getTpl({
            currentDate: this.currentDate,
            standardDate: this.standardDate,
            objByTime: this.objByTime
        }));
    }

    setEvent() {
        // Width값에 따른 모바일/PC UI
        $(window).on('resize', (e) => {
            if(this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => this.resizeTable($(e.target).width()), 300);
        });
        this.resizeTable($(window).width());

        // 모바일 해상도 요일 클릭 이벤트
        $('.schedule-table-head li', this.wrap).click((e) => {
            const width = $(window).width();
            const target = $(e.currentTarget)[0];
            if(width >= this.PC_WIDTH) {
                return false;
            }
            this.SELECTED_COL = $(target).index() + 1;
            $(target).siblings().removeClass('selected');
            $(target).addClass('selected');
            this.resizeTable(width);
        });
    }

    resizeTable(width = 0) {
        // 저해상도에서 1개의 선택된 요일 column만 노출
        if(width < this.PC_WIDTH) {
            $(`.schedule-table-body li`, this.wrap).removeClass('show');
            $(`.schedule-table-body li:nth-child(${this.SELECTED_COL})`, this.wrap).addClass('show');
        }
    }
    setFooter() {
        let scheduleFooter =`
        <div class="schedule-footer">
            <ul class="schedule-footer-typelist">
                <li class="type-red interserver">인터서버</li>
                <li class="type-green localserver">로컬서버</li>
                <li class="type-blue event">이벤트</li>
            </ul>
            <p class="schedule-footer-noti">스케줄표 클릭시 해당 콘텐트의 파워북 페이지로 이동합니다.</p>
        </div>
        `;
        this.wrap.append(scheduleFooter);
    }
}



// WEBPACK FOOTER //
// ./_src/js/schedule/ScheduleTable.js